import Transformer from '../transformer'
import { money, shortDate } from '@/filters'

/**
 * @autor Andres Aguilar <andresyoshimar@gmail.com>
 */

export default class PaymentTransformer extends Transformer {
  static fetch(payment) {
    return {
      id: payment.id,
      addDate: shortDate(payment.add_date),
      amount: money(payment.amount),
      dolar: money(payment.exchange_price),
      package: payment.package,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/extranet/PaymentTransformer.js